import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import useExpress, { expressMutation } from '../../repository/react-query/useExpress';

const baseEndpoint = '/trucks';

const getTrucksQuery = ({ path, includeDeleted, queryParams }) => {
    const { where = {}, ...rest } = queryParams;
    const params = {
        where: {
            ...(includeDeleted ? { deleted_at: 'any' } : { deleted_at: { eq: null } }),
            ...where,
        },
        ...rest,
    };

    const endpoint = path ? `${baseEndpoint}/${path}` : baseEndpoint;
    return useExpress({ endpoint, params });
};

export const useFetchTrucks = ({ path, includeDeleted, queryParams = {}, ...useQueryOptions }) => {
    const queryFn = getTrucksQuery({ path, includeDeleted, queryParams });
    const queryKey = ['trailer-data', { includeDeleted, ...queryParams }];
    return useQuery({ queryKey, queryFn, ...useQueryOptions });
};

export const useUpdateTruck = ({ key }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }) => {
            return expressMutation({
                method: 'PATCH',
                endpoint: `/${baseEndpoint}/${id}`,
                body: data,
            });
        },
        onSuccess: () => {
            if (key) {
                queryClient.invalidateQueries({ queryKey: [key] });
            }
        },
    });
};

export const useDeleteTruck = ({ key }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id }) => {
            return expressMutation({
                method: 'DELETE',
                endpoint: `/${baseEndpoint}/${id}`,
            });
        },
        onSuccess: () => {
            if (key) {
                queryClient.invalidateQueries({ queryKey: [key] });
            }
        },
    });
};
